@if (kind === 'GooglePay') {
  <span class="digital-wallet-image">
    <div class="digital-wallet-image-spacing">
      <i [class]="'fab fa-google-pay fa-2x'"></i>
    </div>
  </span>
}
@if (kind === 'ApplePay') {
  <span class="digital-wallet-image">
    <div class="digital-wallet-image-spacing">
      <i [class]="'fab fa-apple-pay fa-2x'"></i>
    </div>
  </span>
}
@if (kind === 'PayPal') {
  <span class="digital-wallet-image">
    <div class="digital-wallet-image-spacing">
      <i [class]="'fab fa-paypal fa-lg'"></i>
    </div>
  </span>
}
@if (kind === 'Venmo') {
  <span class="digital-wallet-image">
    <img src="/assets/img/venmo-icon.png" height="32px" />
  </span>
}
@if (!kind) {
  <lib-text-table-column>
  </lib-text-table-column>
}
